import { render, staticRenderFns } from "./M_department.vue?vue&type=template&id=f2d83cdc&scoped=true&"
import script from "./M_department.vue?vue&type=script&lang=js&"
export * from "./M_department.vue?vue&type=script&lang=js&"
import style0 from "./M_department.vue?vue&type=style&index=0&id=f2d83cdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d83cdc",
  null
  
)

export default component.exports